const CHECK_INTERVAL = 60000;
const ASSET_MANIFEST_URL = '/asset-manifest.json';

async function checkForUpdates() {
    try {
        const response = await fetch(ASSET_MANIFEST_URL, { cache: 'no-cache' });
        const manifest = await response.json();
        const newVersion = JSON.stringify(manifest.entrypoints);

        const storedVersion = localStorage.getItem('bundle_version');

        if (storedVersion && storedVersion !== newVersion) {
            console.log('[UpdateChecker] Новая версия найдена, обновляем страницу...');
            window.location.reload();
        }

        localStorage.setItem('bundle_version', newVersion);
    } catch (error) {
        console.error('[UpdateChecker] Ошибка при проверке обновлений:', error);
    }
}

setInterval(checkForUpdates, CHECK_INTERVAL);
